{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "Selamat pagi",
        "afternoon": "Selamat tengah hari",
        "evening": "Selamat petang"
      },
      "header": {
        "fallbackUser": "Pengguna",
        "facility": "Kemudahan {{id}}"
      },
      "criticalBanner": {
        "message_one": "{{count}} keputusan kritikal memerlukan pengesahan",
        "message_other": "{{count}} keputusan kritikal memerlukan pengesahan",
        "reviewNow": "Semak sekarang"
      },
      "sections": {
        "overview": "Gambaran Keseluruhan",
        "tasks": "Tugasan",
        "myPatients": "Pesakit Saya",
        "recentActivity": "Aktiviti Terkini",
        "quickActions": "Tindakan Pantas"
      },
      "stats": {
        "activeEncounters": "Lawatan Aktif",
        "pendingOrders": "Arahan Tertangguh",
        "resultsToReview": "Keputusan untuk Disemak",
        "criticalAlerts": "Amaran Kritikal"
      },
      "tasks": {
        "unsignedNotes": "Nota Belum Ditandatangani",
        "criticalResultsPending": "Keputusan Kritikal Tertangguh",
        "cosignaturesNeeded": "Perlu Tandatangan Bersama",
        "ordersToReview": "Arahan untuk Disemak",
        "activeMedications": "Ubat Aktif",
        "admissionsPending": "Kemasukan Tertangguh",
        "ordersToVerify": "Arahan untuk Pengesahan Ahli Farmasi",
        "controlledSubstanceReviews": "Semakan Ubat Terkawal",
        "systemAlerts": "Amaran Sistem",
        "systemStatus": "Status Sistem"
      },
      "systemStatusValue": {
        "healthy": "Sihat"
      },
      "empty": {
        "noPatients": "Tiada pesakit aktif diberikan.",
        "noTasks": "Tiada tugasan khusus untuk peranan ini.",
        "noRecentEncounters": "Tiada lawatan terkini."
      },
      "quickActions": {
        "findPatient": {
          "label": "Cari Pesakit",
          "description": "Cari rekod"
        },
        "registerPatient": {
          "label": "Daftar Pesakit",
          "description": "Tambah pesakit baharu"
        },
        "viewCensus": {
          "label": "Lihat Census",
          "description": "Lawatan aktif"
        },
        "reports": {
          "label": "Laporan",
          "description": "Lihat analitik"
        }
      },
      "viewAll": "Lihat Semua",
      "bedLabel": "Katil {{n}}",
      "admittedLabel": "Dimasukkan {{date}}",
      "fallback": {
        "unknownPatient": "Pesakit Tidak Diketahui",
        "unknownType": "Tidak Diketahui"
      },
      "acuity": {
        "1": "Resusitasi",
        "2": "Kecemasan",
        "3": "Mendesak",
        "4": "Kurang Mendesak",
        "5": "Tidak Mendesak"
      },
      "encounterType": {
        "emergency": "Kecemasan",
        "inpatient": "Pesakit Dalam",
        "outpatient": "Pesakit Luar",
        "observation": "Pemerhatian"
      },
      "encounterStatus": {
        "active": "Aktif",
        "completed": "Selesai",
        "discharged": "Dibenarkan Pulang",
        "cancelled": "Dibatalkan",
        "pending": "Tertangguh"
      }
    },
    "qualityMeasures": {
      "title": "Penunjuk Kualiti",
      "subtitle": "Pantau penunjuk kualiti klinikal dan pematuhan kawal selia",
      "refresh": "Muat Semula",
      "allTypesLabel": "Semua Jenis",
      "allFacilitiesLabel": "Semua Fasiliti",
      "targetPrefix": "Sasaran: {{value}} {{unit}}",
      "updatedPrefix": "Dikemas kini: {{value}}",
      "measureType": {
        "process": "Proses",
        "outcome": "Hasil",
        "structure": "Struktur"
      },
      "summary": {
        "totalMeasures": "Jumlah Penunjuk",
        "meetingTarget": "Mencapai Sasaran",
        "belowTarget": "Di Bawah Sasaran"
      },
      "toasts": {
        "refreshSuccess": "Penunjuk dimuat semula"
      },
      "results": {
        "title": "Keputusan direkodkan",
        "period": "Tempoh",
        "facility": "Fasiliti",
        "denominator": "Penyebut",
        "numerator": "Pengangka",
        "exclusions": "Pengecualian",
        "rate": "Kadar",
        "source": "Sumber",
        "calculated": "Dikira",
        "empty": "Tiada keputusan direkodkan untuk ukuran ini dalam tempoh ini.",
        "loadError": "Tidak dapat memuatkan keputusan yang direkodkan.",
        "allFacilities": "Semua Fasiliti",
        "record": "Rekod hasil"
      },
      "sources": {
        "manual": "Manual",
        "sql-template": "Templat SQL",
        "import": "Import"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "Laporan QRDA dimuat turun",
        "error": "Muat turun QRDA gagal"
      },
      "record": {
        "title": "Rekod hasil kualiti",
        "titleFor": "Rekod hasil — {{code}} {{name}}",
        "subtitle": "Hasil yang direkodkan muncul dalam sejarah ukuran dan disalurkan ke eksport QRDA Kategori III. Merekod semula sesuatu tempoh akan menggantikan baris sebelumnya.",
        "back": "Kembali ke ukuran kualiti",
        "cancel": "Batal",
        "save": "Rekod hasil",
        "measureNotFound": "Ukuran tidak dijumpai. Ia mungkin telah dinyahaktifkan.",
        "fields": {
          "periodStart": "Mula tempoh",
          "periodEnd": "Tamat tempoh",
          "facility": "Fasiliti",
          "allFacilities": "Semua Fasiliti",
          "denominator": "Penyebut",
          "numerator": "Pengangka",
          "exclusions": "Pengecualian",
          "source": "Sumber pengiraan",
          "completeness": "Kelengkapan data",
          "completenessHint": "Pecahan rekod layak dengan data lengkap, 0 hingga 1. Biarkan kosong jika tidak diketahui.",
          "notes": "Nota"
        },
        "errors": {
          "periodStartRequired": "Mula tempoh diperlukan",
          "periodEndRequired": "Tamat tempoh diperlukan",
          "periodOrder": "Tamat tempoh mestilah pada atau selepas mula tempoh",
          "countInvalid": "Masukkan nombor bulat, 0 atau lebih",
          "numeratorExceeds": "Pengangka tidak boleh melebihi penyebut",
          "numeratorExceedsNet": "Pengangka tidak boleh melebihi penyebut tolak pengecualian",
          "sourceRequired": "Sumber pengiraan diperlukan",
          "completenessRange": "Kelengkapan mestilah antara 0 dan 1"
        },
        "toast": {
          "success": "Hasil direkodkan",
          "error": "Perekodan gagal"
        }
      }
    },
    "analyticsDashboard": {
      "title": "Papan Pemuka Analitik",
      "subtitle": "Metrik dan trend prestasi hospital",
      "refresh": "Muat Semula",
      "changeVsPrevPeriod": "{{sign}}{{value}}% vs tempoh sebelum",
      "dateRange": {
        "today": "Hari Ini",
        "7d": "7 Hari",
        "30d": "30 Hari",
        "90d": "90 Hari"
      },
      "facility": {
        "all": "Semua Fasiliti",
        "sgh": "SGH - Singapore General Hospital",
        "nuh": "NUH - National University Hospital",
        "ttsh": "TTSH - Tan Tock Seng Hospital"
      },
      "department": {
        "all": "Semua Jabatan",
        "er": "Kecemasan",
        "icu": "ICU",
        "medsurg": "Perubatan/Pembedahan",
        "peds": "Pediatrik",
        "maternity": "Bersalin"
      },
      "widget": {
        "census": {
          "title": "Bilangan Pesakit Semasa"
        },
        "bedOccupancy": {
          "title": "Penghunian Katil"
        },
        "avgLOS": {
          "title": "Purata Tempoh Penginapan"
        },
        "throughput": {
          "title": "Jumlah Lawatan"
        },
        "readmission": {
          "title": "Pesanan Menunggu"
        }
      },
      "unit": {
        "patients": "pesakit",
        "days": "hari",
        "encounters": "lawatan",
        "orders": "pesanan"
      },
      "charts": {
        "admissionsVsDischarges": "Kemasukan vs Pelepasan",
        "admissionsByDepartment": "Kemasukan Mengikut Jabatan",
        "encounterTypes": "Jenis Lawatan",
        "censusTrend": "Trend Bilangan Pesakit",
        "insufficientData": "Data tidak mencukupi untuk carta",
        "insufficientTrendData": "Data tidak mencukupi untuk carta trend"
      },
      "series": {
        "admissions": "Kemasukan",
        "discharges": "Pelepasan",
        "census": "Bilangan Pesakit"
      },
      "toasts": {
        "refreshSuccess": "Papan pemuka dimuat semula"
      }
    },
    "reportRunner": {
      "title": "Pelancar Laporan",
      "subtitle": "Jana dan eksport laporan klinikal, kewangan dan operasi",
      "scheduleButton": "Jadualkan Laporan",
      "searchPlaceholder": "Cari laporan...",
      "allCategoriesLabel": "Semua Laporan",
      "category": {
        "clinical": "Klinikal",
        "financial": "Kewangan",
        "operational": "Operasi",
        "quality": "Kualiti"
      },
      "emptyState": {
        "title": "Pilih laporan untuk bermula",
        "subtitle": "Pilih daripada senarai laporan di sebelah kiri"
      },
      "noResults": "Tiada laporan yang sepadan dengan penapis anda",
      "parametersHeading": "Parameter",
      "selectOptionPlaceholder": "Pilih...",
      "runButton": "Jalankan Laporan",
      "runningReport": "Menjalankan laporan...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "Tarikh (waktu tempatan kemudahan)",
        "facilityTimeZone": "Zon waktu kemudahan",
        "encounterDate": "Tarikh (UTC)"
      },
      "resultSummary": {
        "rows": "Menunjukkan {{shown}} daripada {{total}} baris",
        "executed": "Dilaksanakan dalam {{ms}}ms"
      },
      "toasts": {
        "success": "Laporan selesai dalam {{executionTimeMs}}ms - {{rowCount}} baris",
        "failed": "Gagal menjalankan laporan",
        "missingFields": "Sila isi medan yang diperlukan: {{missingFields}}",
        "exporting": "Mengeksport sebagai {{format}}... (penanda tempat)",
        "scheduledPlaceholder": "Persediaan laporan berjadual (penanda tempat)"
      }
    }
  }
}
